(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sidebar"]) return;
  try {
    
  $(document).ready(function(){
    // Automatically expand all parents of active links
    $(".toggle-menu a.active").each(function(){
      $(this).parents("li").each(function(){
        $(this).children(".sub-menu").show();
        $(this).addClass("open");
      });
    });

    // First-level toggle (Men) - not clickable
    $(".toggle-menu > li.toggle-content > a").on("click", function(e){
      var $parent = $(this).parent();
      var $submenu = $parent.find("> .sub-menu");

      if ($submenu.length) {
        e.preventDefault(); // prevent Men from navigating
        $submenu.slideToggle(200);
        $parent.toggleClass("open");
      }
    });

    // Second and third-level toggles (Clothing, Pants)
    $(".toggle-menu li li > a, .toggle-menu li li li > a").on("click", function(e){
      var $parent = $(this).parent();
      var $submenu = $parent.find("> .sub-menu");

      if ($submenu.length) {
        $submenu.slideToggle(200);
        $parent.toggleClass("open");
      }
      // Link navigation is allowed
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-facebook-message"] && !window.DesignMode) return;
  try {
    
	jQuery(document).ready(function($) {
		$(document).on('click', '.ss-fb-ms-bottom', function() {
			$('.ss-fb-ms-inner').show();
			$(this).hide();
		})

		$(document).on('click', '.offline_heading', function() {
			$('.ss-fb-ms-inner').hide();
			$('.ss-fb-ms-bottom').show();
		})
	})

  } catch(e) { console.error(e); }
})();
})();
